import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import { useState, useEffect } from "react";
import L from "leaflet";
import "./stiluri/LocatieHarta.css";

const defaultIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

export default function LocatieHarta({ onLocationSelect }) {
  const [markerPosition, setMarkerPosition] = useState<[number, number] | null>(
    null
  );
    const [afiseazaHarta, setAfiseazaHarta] = useState(false);


  function reverseGeocode(lat: number, lng: number) {
    fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
    )
      .then((res) => res.json())
      .then((data) => {
        const adresa = data.address || {};
        const judet =
          adresa.state ||
          adresa.county ||
          adresa.region ||
          adresa.state_district ||
          "";

        onLocationSelect?.({
          strada: adresa.road || "",
          numar: adresa.house_number || "",
          judet: judet,
          oras: adresa.city || adresa.town || adresa.village || "",
          taraIdentificare: adresa.country || "",
        });
      });
  }

  function LocationMarker() {
    const eventHandlers = {
      dragend(e) {
        const marker = e.target;
        const position = marker.getLatLng();
        setMarkerPosition([position.lat, position.lng]);
        reverseGeocode(position.lat, position.lng);
      },
    };

    return markerPosition ? (
      <Marker
        position={markerPosition}
        draggable={true}
        eventHandlers={eventHandlers}
        icon={defaultIcon}
      />
    ) : null;
  }

  // Hook pentru map, folosit din afara hărții
  function Locator({
    markerPosition,
  }: {
    markerPosition: [number, number] | null;
  }) {
    const map = useMap();

    useEffect(() => {
      if (markerPosition) {
        map.setView(markerPosition, 13);
      }
    }, [markerPosition, map]);

    return null;
  }

  // Funcție apelată când se apasă pe buton (din afara hărții)
  const handleLocate = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          setMarkerPosition([lat, lng]);
          reverseGeocode(lat, lng);
        },
        () => {
          alert("Nu am putut obține locația.");
        }
      );
    }
  };

  return (
    <div>
      {/* Buton ÎN AFARA hărții */}
      <button
  type="button"
  className="btn-harta"
  onClick={handleLocate}
>
  📍 Localizează-mă
</button>

<button
  type="button"
  className="btn-harta btn-harta-secondary"
  onClick={() => setAfiseazaHarta((prev) => !prev)}
>
  {afiseazaHarta ? "🗺️ Ascunde harta" : "🗺️ Afișează harta"}
</button>


      {/* Harta - afișată doar dacă afiseazaHarta === true */}
      {afiseazaHarta && (
        <div style={{ height: "400px", width: "100%" }}>
          <MapContainer
            center={markerPosition || [44.4268, 26.1025]}
            zoom={13}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <LocationMarker />
          <Locator markerPosition={markerPosition} />
        </MapContainer>
      </div>
      )}
    </div>
      
  );
}
